import request from '@/utils/request'

export async function getData(params) {
  return request({
    url: '/statistics/depart_car_application/statistics',
    method: 'get',
    params,
  })
}
export async function exportReport(params) {
  return request({
    url: '/statistics/depart_car_application/export',
    method: 'get',
    params,
  })
}
